// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { FieldsFactory } from '../Factory/FieldsFactory';
import { Message } from '@shared/utils/DirectMessages/Message';
import { PFixMessage } from './PFixMessage';
export class TradingSignalSeenRequestMessage extends PFixMessage {
    constructor(fieldSet) {
        super(Message.CODE_TRADING_SIGNAL_REQ_SEEN_MESSAGE, fieldSet);
    }
    setTradingSignalId(tradingSignalId) {
        this.setFieldValue(FieldsFactory.FIELD_TRADING_SIGNAL_ID, tradingSignalId);
    }
}
